"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _isText = require("../../helpers/isText");

var _svgs = require("../../svgs");

var _utils = require("../../utils");

var _useUpdateEffect = require("../../utils/useUpdateEffect");

var _Box = require("../Box");

var _Clickable = require("../Clickable");

var _Flex = require("../Flex");

var _Spacer = require("../Spacer");

var _Text = require("../Text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * A `Popover` is a small modal-type element which is anchored, and can be
 * positioned relative to, another element.
 */
var Popover = function Popover(_ref) {
  var title = _ref.title,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "top" : _ref$placement,
      _ref$visible = _ref.visible,
      _visible = _ref$visible === void 0 ? false : _ref$visible,
      children = _ref.children,
      popover = _ref.popover;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1]; // If prop updates/set initial visibility.


  (0, _react.useEffect)(function () {
    setVisible(_visible);
  }, [_visible]); // Yields focus back and forth between popover and anchor

  (0, _useUpdateEffect.useUpdateEffect)(function () {
    if (visible && tooltipRef.current) {
      tooltipRef.current.focus();
      return;
    }

    if (!anchorRef.current) return;
    anchorRef.current.focus();
  }, [visible]);

  var onVisible = function onVisible() {
    return setVisible(true);
  };

  var onHide = function onHide() {
    return setVisible(false);
  };

  (0, _react.useEffect)(function () {
    var handleKeydown = function handleKeydown(event) {
      if (event.key === "Escape") {
        onHide();
      }
    };

    document.addEventListener("keydown", handleKeydown);
    return function () {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  var _usePosition = (0, _utils.usePosition)({
    position: placement,
    offset: 10,
    active: visible
  }),
      anchorRef = _usePosition.anchorRef,
      tooltipRef = _usePosition.tooltipRef;

  (0, _utils.useClickOutside)({
    ref: tooltipRef,
    onClickOutside: onHide,
    when: visible,
    type: "click"
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children({
    anchorRef: anchorRef,
    onVisible: onVisible,
    onHide: onHide
  }), visible && /*#__PURE__*/_react.default.createElement(Tip, {
    tabIndex: 0,
    ref: tooltipRef,
    zIndex: 1,
    display: "inline-block",
    bg: "white100",
    p: 2
  }, title && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    alignItems: "center",
    flex: 1,
    justifyContent: "space-between"
  }, (0, _isText.isText)(title) ? /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "lg",
    lineHeight: 1
  }, title) : title, /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    ml: 4
  })), /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    mt: 0.5
  })), /*#__PURE__*/_react.default.createElement(_Clickable.Clickable, {
    position: "absolute",
    right: 0,
    top: 0,
    pt: 2,
    px: 1,
    mx: 0.5,
    onClick: onHide,
    "aria-label": "Close"
  }, /*#__PURE__*/_react.default.createElement(_svgs.CloseIcon, {
    fill: "black100",
    display: "block"
  })), !title && /*#__PURE__*/_react.default.createElement(_Spacer.Spacer, {
    mt: 2
  }), popover));
};

exports.Popover = Popover;
var Tip = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Popover__Tip",
  componentId: "x2qqfz-0"
})(["position:fixed;z-index:1;text-align:left;transition:opacity 250ms ease-out;box-shadow:", ";"], _helpers.DROP_SHADOW);
//# sourceMappingURL=Popover.js.map